import { render } from "./VaccinationDetail.vue?vue&type=template&id=4819dc3e&scoped=true"
import script from "./VaccinationDetail.vue?vue&type=script&lang=js"
export * from "./VaccinationDetail.vue?vue&type=script&lang=js"

import "./VaccinationDetail.vue?vue&type=style&index=0&id=4819dc3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4819dc3e"]])

export default __exports__